import { unsafeCSS, type CSSResult } from 'lit';
import { toCSSValue, type ColorToken } from '@loadsmart/miranda-tokens';

/**
 * Get color token as lit's `CSSResult`
 * @param {ColorToken} token - Color token
 * @param {number} [alpha] - opacity
 * @returns {CSSResult}
 */
function getColor(token: ColorToken, alpha = 1): CSSResult {
	return unsafeCSS(toCSSValue(token, alpha));
}

export default getColor;
